import { useMutation } from "@apollo/client";
import { SAVE_ENUM_DYNAMIC_ATTRIBUTE } from "../api/save-enum-dynamic-attribute";
import { FieldsType } from "./types";
import { GET_ENTITY_ATTRIBUTES } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor";

export function useSaveEnumDynamicAttribute({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const [saveEnumDynamicAttribute, { loading }] = useMutation(
    SAVE_ENUM_DYNAMIC_ATTRIBUTE,
    {
      refetchQueries: [GET_ENTITY_ATTRIBUTES],
    },
  );

  const save = async (attribute: FieldsType) => {
    const response = await saveEnumDynamicAttribute({
      variables: {
        attribute,
      },
    });

    if (response.data?.saveEnumDynamicAttribute) {
      afterSubmit?.();
    }
  };

  return {
    save,
    loading,
  };
}
